import React from "react";
import CircleIcon from "../../../../../icons/CircleIcon";

interface KycStatusNoticeProps {
  variant: "info" | "warning" | "success";
  message: string;
}

const variantClasses: Record<KycStatusNoticeProps["variant"], string> = {
  info: "bg-blue-100 border-blue-500 text-blue-800",
  warning: "bg-yellow-100 border-yellow-500 text-yellow-800",
  success: "bg-green-100 border-green-500 text-green-800",
};

const KycStatusNotice = ({ variant, message }: KycStatusNoticeProps) => {
  const baseClasses = "flex items-center space-x-3 p-4 border-l-4 rounded-md";
  const colorClasses = variantClasses[variant];

  return (
    <div className={`${baseClasses} ${colorClasses}`}>
      <CircleIcon className="w-6 h-6 flex-shrink-0" />
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
};

export default KycStatusNotice;
